import styled from 'styled-components';
import { themeColor } from '~/common/utils/theme';
import { Form } from '~/ui/components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: 8px;
  align-items: center;

  button {
    min-width: 170px;
  }
`;

export const StyledForm = styled(Form)`
  margin-top: 24px;
  height: calc(100vh - 144px);
  justify-content: space-between;
  flex-wrap: nowrap;

  .input-list {
    overflow: scroll;

    &::-webkit-scrollbar {
      width: 4px;
    }
  }

  .editor-container {
    border: 1.5px solid ${themeColor('divider.primary')};
  }

  .ant-form-item-control.has-error .editor-container {
    border-color: ${themeColor('negative.primary')};
  }
`;
